export function canBringEveryoneHere(
  selectedId: string,
  liveId: string | null,
  selectedStatus: "draft" | "active" | "closed" | "archived" | undefined,
): boolean {
  return selectedId === liveId && selectedStatus === "active";
}

export function makeLiveBrowserContinuityCopy(hasDifferentLiveSession: boolean): string {
  const previousSessionCopy = hasDifferentLiveSession
    ? " The current live session will be ended and its final summary process will begin."
    : "";
  return `${previousSessionCopy} Existing participant, admin, moderator, and projector browsers will stay where they are until you use Bring everyone here.`;
}
